import { matchPath } from "react-router-dom";

export function isEventManagementPage(location: { pathname: string }) {
  const { pathname = "" } = location;
  return Boolean(matchPath({ path: "/event-management" }, pathname)?.pathname) ?? false;
}
